import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F59.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame59() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F59_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F59_entryBox">
                    <div className="F59_paragraph">
                        {language === 'english' ?
                            <p className="F59_paragraphEnglish">Another senior girl intervenes and tells Saira that during menstruation we should stay at home as the blood is dirty and it makes us impure</p>
                            :
                            <p className="F59_paragraphUrdu">گروپ میں سے ایک اور لڑکی کہتی ہے کہ اس کا کوئی فائدہ نہں کیونکہ ماہواری کے دوران ویسے بھی باہر نہیں نکلنا چاہیئے۔ ماہواری کا خون گندا ہوتا ہے اور ناپاکی کرتا ہے</p>
                        }
                    </div>

                    <div className="F59_timeline">
                        <div className='F59_timelineBar'>
                            <div className='F59_timelineFill'></div>
                            <span className='F59_timelineText'>8/14</span>
                        </div>
                    </div>

                    <div className="F59_nextFrames">
                        <div className="F59_nextFrame1"></div>
                        <div className="F59_nextFrame2"></div>
                        <div className="F59_nextFrame3"></div>
                    </div>

                    <div className='F59_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(8)) }} className='F59_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame59;